<script setup>
import { ref, reactive } from "vue";
import { request } from "../utils/request.js";
import { openPhotoSwipe } from "./PhotoSwipe.js";
import Modal18y from './Modal18y.vue';

let book = ref({});

const show = ref(false);
const showAds = ref(false);
const view = ref("basic");
const showModal = ref(false);

const close = () => {
  show.value = false;
  showModal.value = false;
  //window.location.hash = '';
  document.querySelector(".newspapper-preview").scrollTo({ top: 0 });
  document.body.classList.remove("newspapper-preview-active");
};

const changeView = (_view) => {
  view.value = _view;
};

window.showBrowser = async (id) => {
  window.location.hash = "book-" + id;
  book.value = await request("/wp-admin/admin-ajax.php?action=fetch-book&id=" + id, {
    method: "GET"
  });

  if (book.value.age18plus) {
    showModal.value = true;
  }

  if ("ontouchstart" in document.documentElement || localStorage.photoswipe == 1) {
    openPhotoSwipe(id);
  } else {
    show.value = true;
    document.body.classList.add("newspapper-preview-active");

    setTimeout(() => {
      showAds.value = true;
    }, 1000)
  }
};

if (window.location.hash.includes("book-")) {
  let id = window.location.hash.replace("#book-", "");
  window.showBrowser(id);
}
</script>

<template>
  <div class="newspapper-preview" :class="{active:show}">
    <div class="newspapper-nav">
      <div class="newspapper-nav-inner">
        <a class="newspapper-nav-item newspapper-nav-logo" href="/">
          <img src="../assets/logo-symbol.svg"/>
        </a>
        <a class="newspapper-nav-item newspapper-nav-tab newspapper-nav-basic"
           :class="{'newspapper-nav-active':view=='basic'}" @click="changeView('basic')">
          standard
        </a>
        <a v-if="book.flipbook" class="newspapper-nav-item newspapper-nav-tab newspapper-nav-flipbook"
           :class="{'newspapper-nav-active':view=='flipbook'}"
           @click="changeView('flipbook')">
          Flipbook
        </a>
        <a v-if="book.pdf_url" class="newspapper-nav-item newspapper-nav-tab newspapper-nav-pdf"
           :class="{'newspapper-nav-active':view=='pdf'}"
           @click="changeView('pdf')">
          PDF
        </a>
        <a v-if="book.pdf_url" class="newspapper-nav-item newspapper-nav-download" download="test.pdf"
           :href="book.pdf_url">
          Herunterladen
        </a>
        <a href="#close" class="newspapper-nav-item newspapper-nav-close" @click="close()">
          schließen
        </a>
      </div>
    </div>
    <div class="newspapper-content">
      <div id="basic" class="newspapper-content-item" :style="{display:view=='basic' ? 'block':'none'}">
        <div class="adsense-left" v-if="showAds">
          <iframe src="/wp-content/themes/alleprospekte/left-ads.html" style="height:100%"></iframe>
        </div>
        <div class="adsense-right" v-if="showAds">
          <iframe src="/wp-content/themes/alleprospekte/right-ads.html" style="height:100%"></iframe>
        </div>
        <div class="pages-list">
          <div v-for="(page, index) in book.pages" class="pages-list__page">
            <a class="pages-list__page__label" :href="'#seite-' + (index+1)"
               :id="'seite-' + (index+1)"><span>Seite {{ index + 1 }} von {{ book.pages.length }}</span></a>
            <img
                class="pages-list__page__img lazy"
                loading="lazy"
                :style="page.aspect_ratio ? 'aspect-ratio:' + page.aspect_ratio : ''"
                :src="page.src"/>
          </div>
        </div>
      </div>
      <div v-if="book.flipbook && view=='flipbook'" id="flipbook" class="newspapper-content-item">
        <iframe allowfullscreen :src="book.flipbook"></iframe>
      </div>
      <div v-if="book.pdf_url && view=='pdf'" id="pdf" class="newspapper-content-item">
        <iframe :src="book.pdf_url"></iframe>
      </div>
    </div>
  </div>
  <Modal18y v-if="showModal" @confirm="showModal=false" @close="close" />
</template>
